






















import { Component, Vue, Ref } from "vue-property-decorator";

import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import NumberPickerComponent from "@/components/common/NumberPickerComponent.vue";
import { viewAdditionalPauseDurationOptionsClientAccess } from "@/permissions/ClientPermissions";

@Component({
  components: {
    "number-picker": NumberPickerComponent,
    "base-dialog": BaseDialogComponent,
  },
})
export default class PauseComBoxComponent extends Vue {
  resolve?: (value: number) => void = undefined;
  reject?: (reason: string) => void = undefined;

  confirmationMessage = "";

  pauseDurationInMin = 30;
  pauseDurationInMinOptions = viewAdditionalPauseDurationOptionsClientAccess()
    ? [30, 60, 90, 120, 240]
    : [30, 60, 90];

  get pauseDurationInMinFormatter() {
    return (pauseDurationInMin: number) => {
      return pauseDurationInMin.toString();
    };
  }

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  async show(serialNumber: string, confirmationMessage: string) {
    this.confirmationMessage = confirmationMessage;
    this.baseDialogComponent.show({
      title: this.$t("comBoxDetail.pause.title", [serialNumber]).toString(),
      styleAsAlertDialog: true,
      positiveButtonText: this.$t("comBoxDetail.pause.confirm").toString(),
      persistent: true,
    });

    return new Promise<number>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.resolve && this.resolve(this.pauseDurationInMin);
  }
}
